import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import {
  DashboardOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  SwapOutlined,
  BellOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const { Sider } = Layout;
const { Title } = Typography;

const InventorySidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      width={250}
      breakpoint="lg"        // collapse automatically on screens smaller than 'lg'
      collapsedWidth={0}     // fully hide sidebar on small screens
      style={{ minHeight: '100vh' }}
    >
      <div style={{ textAlign: 'center', padding: '16px' }}>
        <Title level={4} style={{ color: 'white', margin: 0 }}>
          JS-Inventory
        </Title>
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        defaultOpenKeys={['quickLinks', 'inventoryMenu']}
      >
          <Menu.Item key="/dashboard" icon={<DashboardOutlined />}>
          <Link to="/inventory/dashboard">Dashboard</Link>
        </Menu.Item>
         <Menu.Item key="/inventory/search" icon={<SearchOutlined />}>
            <Link to="/inventory/search">Search Spare Part</Link>
          </Menu.Item>
        <Menu.SubMenu key="quickLinks" title="Quick Links">
          <Menu.Item key="/transfer" icon={<SwapOutlined />}>
            <Link to="/inventory/transfer">Transfer Spare Part</Link>
          </Menu.Item>
          <Menu.Item key="/accept" icon={<FileTextOutlined />}>
            <Link to="/inventory/accept">Accept Spare Part</Link>
          </Menu.Item>
           <Menu.Item key="/inventory/send" icon={<FileTextOutlined />}>
            <Link to="/inventory/send">Send Spare Part</Link>
          </Menu.Item>
          <Menu.Item key="/notifications" icon={<BellOutlined />}>
            <Link to="/inventory/notifications">Notifications</Link>
          </Menu.Item>
        </Menu.SubMenu>

        <Menu.SubMenu key="inventoryMenu" title="Manage Inventory">
          <Menu.Item key="/list" icon={<DatabaseOutlined />}>
            <Link to="/inventory/list">Inventory List</Link>
          </Menu.Item>
          <Menu.Item key="/log" icon={<FileTextOutlined />}>
            <Link to="/inventory/log">Inventory Log</Link>
          </Menu.Item>
         
        </Menu.SubMenu>

      
      </Menu>
    </Sider>
  );
};

export default InventorySidebar;
